export enum ReviewForm {
  Rate = "Rate",
  Review = "Review",
  Success = "Success",
}
